import { Roles } from 'consts/authConsts'
import useAccountOwnerId from 'hooks/useAccountOwnerId'
import useQueryParams from 'hooks/useQueryParams'
import { isUserOfRole } from 'utils/authUtils'

export default () => {
  const { queryParams } = useQueryParams()
  const isDevAdmin = isUserOfRole([Roles.DevAdmin])

  const fallbackAccountOwnerId = useAccountOwnerId()
  const accountOwnerId =
    isDevAdmin && queryParams.copilotDoctorId ? queryParams.copilotDoctorId : fallbackAccountOwnerId

  return accountOwnerId
}
